export default {
  namespaced: true,
  state: {
    accessToken: null,
    userData: null
  },
  getters: {
    getAccessToken(state) {
      state.accessToken = state.accessToken || localStorage.accessToken
      return state.accessToken
    },
    getUserData(state) {
      state.userData = localStorage.userData || '{}'
      return JSON.parse(state.userData)
    }
  },
  mutations: {
    storeLogin(state, { accessToken = '', userData }) {
      state.userData = userData
      state.accessToken = accessToken
      localStorage.userData = userData
      localStorage.accessToken = accessToken
    },
    setUserData(state, { userData = {} }) {
      state.userData = userData
      localStorage.userData = JSON.stringify(userData)
    },
    storeLogout(state) {
      state.userData = null
      state.accessToken = null
      delete localStorage.deviceInfo
      delete localStorage.accessToken
      delete localStorage.userData
    }
  },
  actions: {
    storeLogout({ commit }) {
      if (!confirm('로그아웃하시겠습니까?')) return false
      commit('storeLogout')
      location.reload()
    }
  }
}
